var DraftRenderer, EditorDecorators, EditorRenderMaps, isDraftContent, isEmptyNonStringContent, toPlainContent, _ref;

DraftRenderer = require('lib/draft_utils').DraftContentRenderer;

EditorDecorators = require('lib/editor_decorators');

EditorRenderMaps = require('lib/editor_render_maps');

_ref = require('lib/services/document_sections_exporter/utils'), isDraftContent = _ref.isDraftContent, isEmptyNonStringContent = _ref.isEmptyNonStringContent, toPlainContent = _ref.toPlainContent;

module.exports = {
  renderDraftJsContentToHTML: function(data, attachments, referencesMap) {
    var draftRenderer, plain, renderOptions, rendered;
    if (attachments == null) {
      attachments = {};
    }
    if (referencesMap == null) {
      referencesMap = {};
    }
    if (_.isString(data)) {
      return data;
    }
    plain = toPlainContent(data);
    if (isEmptyNonStringContent(plain)) {
      return '';
    }
    if (!isDraftContent(plain)) {
      return '';
    }
    renderOptions = {
      customDecorators: EditorDecorators.referenceDecorator,
      customEntityRenderers: EditorRenderMaps,
      attachments: Immutable.fromJS(attachments)
    };
    draftRenderer = new DraftRenderer(renderOptions);
    rendered = draftRenderer.rawContentToHTML(plain);
    draftRenderer.dispose();
    return _.chain(referencesMap).pairs().reduce(function(content, _arg) {
      var gdtReferenceId, jsonldReferenceId;
      gdtReferenceId = _arg[0], jsonldReferenceId = _arg[1];
      return content.replace(RegExp("data-refid=\\\"" + gdtReferenceId, "g"), "data-refid=\"" + jsonldReferenceId);
    }, rendered).value();
  }
};
